<template>
  <div class="gray-bcg">
    <myheader class="relative" />
    <img
      src="../../assets/image/blueShape.png"
      alt="blueShape"
      class="blueShape"
      width="50%"
    />
    <img
      src="../../assets/image/greenShape.png"
      alt="greenShape"
      width="30%"
      class="greenShape"
    />
    <TrackingDetails class="relative"/>
    <myfooter class="relative" />
  </div>
</template>
<script>
import myheader from "../../components/Share/Header.vue";
import myfooter from "../../components/Share/Footer.vue";
import TrackingDetails from "../../components/TrackingDetails";

export default {
  data() {
    return {

    };
  },
  components: {
    myheader,
    myfooter,
    TrackingDetails,
  },
  mounted() {

  },
};
</script>
<style scoped>
.greenShape {
  position: absolute;
  top: 20%;
  right: 90%;
}
.blueShape {
  position: absolute;
  top: 20%;
  right: -40%;
}
.pnel-btn {
  background-color: #e76f51 !important;
}
.transition {
  transition: 1s;
}
.currentRout {
  color: #3c56c8 !important;
}
.currentComponent {
  text-decoration: underline;
}
</style>
